import { ChangeDetectionStrategy, Component } from '@angular/core';
import {
  FormlyFieldProps as CoreFormlyFieldProps,
  FieldWrapper,
  FormlyFieldConfig,
  FormlyModule,
} from '@ngx-formly/core';
import { TooltipModule } from 'primeng/tooltip';

export interface FormlyFieldProps extends CoreFormlyFieldProps {
  hideRequiredMarker?: boolean;
  hideLabel?: boolean;
  disabledReason?: string;
  tooltip?: string;
}

@Component({
  selector: 'kon-form-field-wrapper',
  imports: [FormlyModule, TooltipModule],
  template: `
    <div class="p-field flex flex-col mb-4">
      @if (
        props.label && props.hideLabel !== true && field.type !== 'checkbox'
      ) {
        <label [for]="id" class="mb-1">
          {{ props.label }}
          @if (props.required && props.hideRequiredMarker !== true) {
            <span aria-hidden="true">*</span>
          }
          @if (
            (props.disabled && props.disabledReason) || props.tooltip;
            as tooltip
          ) {
            <i
              class="text-sm pi pi-info-circle ml-1 translate-y-[0.05rem]"
              [pTooltip]="tooltip"
            ></i>
          }
        </label>
      }

      <ng-container #fieldComponent></ng-container>

      @if (showError) {
        <small class="p-error">
          <formly-validation-message
            class="ui-message-text text-danger-500"
            [field]="field"
          ></formly-validation-message>
        </small>
      }

      @if (props.description) {
        <small class="p-help text-gray-400">
          <div [innerHTML]="props.description"></div>
        </small>
      }
    </div>
  `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyFormFieldWrapperComponent extends FieldWrapper<
  FormlyFieldConfig<FormlyFieldProps>
> {
  // @HostBinding('class.p-float-label') floatLabel = true;
}
